<div class="container min-width-500">
  <form [formGroup]="form" (ngSubmit)="crear()" class="form">
    <div class="row col-12 mt-5 p-0">
      <div class="col">
        <label for="name" class="padding-2">Patente </label>
        <input type="text" formControlName="patente" class="" pInputText />
        <span
          class="danger"
          *ngIf="
            form.get('patente').hasError('required') &&
            form.get('patente').touched
          "
        >
          <br />
          <small class="p-error"
            >Este campo es <strong>requerido</strong></small
          >
        </span>
      </div>
      <div class="col">
        <label for="name" class="padding-2">Marca </label><br />
        <p-dropdown
          (onChange)="otherBrand($event)"
          [options]="marcas"
          formControlName="marca"
          placeholder="Seleccionar marca"
          optionLabel="name"
          optionValue="code"
          [showClear]="true"
        ></p-dropdown>

        <span
          class="danger"
          *ngIf="
            form.get('marca').hasError('required') && form.get('marca').touched
          "
        >
          <br />
          <small class="p-error"
            >Este campo es <strong>requerido</strong></small
          >
        </span>
      </div>
    </div>
    <div
      class="row col-12 mt-5 p-0"
      [hidden]="showOtherBrand"
      *ngIf="this.form.get('otherBrand')"
    >
      <div class="col">
        <label for="name" class="padding-2"
          >Escriba el nombre de la marca
        </label>
        <input
          type="text"
          formControlName="otherBrand"
          class="form-control"
          pInputText
        />
        <span
          class="danger"
          *ngIf="
            form.get('otherBrand').hasError('required') &&
            form.get('otherBrand').touched
          "
        >
          <br />
          <small class="p-error"
            >Este campo es <strong>requerido</strong></small
          >
        </span>
      </div>
    </div>
    <div class="row col-12 mt-5 p-0">
      <div class="col">
        <label for="name" class="padding-2">Modelo </label>
        <input
          type="text"
          formControlName="modelo"
          class="form-control"
          pInputText
        />
        <span
          class="danger"
          *ngIf="
            form.get('modelo').hasError('required') &&
            form.get('modelo').touched
          "
        >
          <br />
          <small class="p-error"
            >Este campo es <strong>requerido</strong></small
          >
        </span>
      </div>
    </div>
    <div class="row col-12 mt-5 p-0">
      <div class="col">
        <label for="length" class="padding-2">Largo </label>
      </div>
      <div class="col">
        <label for="name" class="padding-2">Alto </label>
      </div>
    </div>
    <div class="row col-12 p-0">
      <div class="col">
        <input type="text" formControlName="length" pInputText />
        <span
          class="danger"
          *ngIf="
            form.get('length').hasError('required') &&
            form.get('length').touched
          "
        >
          <br />
          <small class="p-error"
            >Este campo es <strong>requerido</strong></small
          >
        </span>
      </div>

      <div class="col">
        <input type="text" formControlName="height" pInputText />
        <span
          class="danger"
          *ngIf="
            form.get('height').hasError('required') &&
            form.get('height').touched
          "
        >
          <br />
          <small class="p-error"
            >Este campo es <strong>requerido</strong></small
          >
        </span>
      </div>
    </div>
    <div class="row col-12 mt-5 p-0">
      <div class="col">
        <label for="width" class="padding-2">Ancho </label>
        <input type="text" formControlName="width" pInputText />
        <span
          class="danger"
          *ngIf="
            form.get('width').hasError('required') && form.get('width').touched
          "
        >
          <br />
          <small class="p-error"
            >Este campo es <strong>requerido</strong></small
          >
        </span>
      </div>

      <div class="col">
        <label for="details" class="padding-2">Detalles </label>
        <input type="text" formControlName="details" pInputText />
        <span
          class="danger"
          *ngIf="
            form.get('details').hasError('required') &&
            form.get('details').touched
          "
        >
          <br />
          <small class="p-error"
            >Este campo es <strong>requerido</strong></small
          >
        </span>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col">
        <p-button
          type="submit"
          [disabled]="form.invalid"
          label="Confirmar"
          class="p-button-primary p-button-text"
        ></p-button>
      </div>
    </div>
  </form>
</div>
